export const tabs = {
    base: {
        background: "cyan",
        color: "black"
    }
}